export default __webpack_public_path__ + "static/media/pinecone.7e339d40.jpg";